<!--
 * @Author: Src
 * @Date: 2024-12-18 08:46:19
 * @LastEditTime: 2025-09-19 15:02:53
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/views/shop/comments/shopNameField.vue
 * @Description: 头部注释配置模板
-->
<template>
    <div>
        <div class="el-input__inner" @click="change">
            {{ val }}
        </div>

        <!-- <el-select v-model="val" placeholder="输入店铺名称" filterable remote reserve-keyword :remote-method="remoteMethod">
            <el-option v-for="item in regions" :key="item.id" :label="item.name" :value="item.id">
                <div>名称:{{ item.name }}</div>
                <div style="font-size: 10px;color: #8492a6; width: 100%;" class="optoon_div">
                    地址:{{ `${item.cityName}${item.adname}${item.address}` }}</div>
            </el-option>
        </el-select> -->
        <el-drawer :visible.sync="drawer" :direction="'btt'" :before-close="handleClose" height="70vh"
            :append-to-body="true">
            <div style="height: 70vh;">
                <div class="drawer_top">
                    <el-input v-model="shopName" @input="changeShopName"/>
                    <el-button @click="searchShop">搜索</el-button>
                </div>
                <div>
                    <ul>
                        <li v-for="(item, index) in regions" :key="index" @click="selectShop(item)" class="drawer_list">
                            <div>名称:{{ item.name }}</div>
                            <div style="font-size: 10px;color: #8492a6;" class="optoon_div">
                                地址:{{ `${item.cityName}${item.adname}${item.address}` }}</div>

                        </li>
                    </ul>
                </div>
            </div>
        </el-drawer>
    </div>
</template>
<script lang="ts">
import { Vue, Component, Watch, Model, Prop, Ref } from 'vue-property-decorator';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';

// interface City {
//     code: string; // 城市编号
//     depth: number;
//     id: number; // 城市id
//     name: string;
//     pid?: number;
//     pinyin: string;
//     pinyin2: string;
//     province?: City;
// }

@Component({})
export default class CityField extends Vue {

    @lazyInject(ShopService)
    protected shopService!: ShopService;

    val: any = '';

    @Ref('input')
    input!: Vue;

    regions: any[] = [];

    valID = '';

    drawer = false;

    shop = '';

    shopName = '';
    @Prop({
        type: String,
    })
    CityId!: string;

    @Watch('val')
    watchInternalVal(): void {
        if (this.val !== null) {
            this.$emit('changeShop', this.shop);
            this.$emit('change', this.val);
        } else {
            this.$emit('change', '');
            this.$emit('changeShop', '');

        }
    }


    @Model('change', {
        type: String,
    })
    value!: string;

    @Watch('value')
    watchValue() {
        if (!this.value || this.value === '') {
            this.val = null;
            return;
        }
        this.val = this.value;
    }

    mounted() {
        this.watchValue();
    }

    selectShop(item: any) {
        this.valID = item.id;
        this.val = item.name;
        this.drawer = false;
        this.shop = item;
        // this.$emit('changeShop', item);
    }
    handleClose() {
        this.drawer = false
    }
    change() {
        this.drawer = true;
        // const drawerTyoe = document.getElementsByClassName('el-drawer')[0]
        // // setTimeout(() => {
        // //     drawerTyoe.removeAttribute('style')
        // // }, 100)
        // console.log(drawerTyoe);
        this.shopName = ''
        this.regions = []
        // this.input.blur();
    }
    changeShopName(){
        // const drawerTyoe = document.getElementsByClassName('el-drawer')[0]
        // setTimeout(() => {
        //     drawerTyoe.removeAttribute('style')
        // }, 100)
    }
    searchShop() {
        this.remoteMethod(this.shopName);
    }

    async remoteMethod(query: string) {
        const res = await this.shopService.getPoi(this.CityId, query);
        this.regions = res;
    }
}
</script>
<style lang="scss" scoped>
::v-deep.el-select-dropdown__item {
    //   white-space: pre-wrap !important;
    // max-width: 300px;
    height: auto;
}

::v-deep.el-drawer {
    height: 70vh !important;
}
::v-deep .btt {
    height: 70vh !important;
}

.optoon_div {
    // max-width: 300px;
    word-wrap: break-word !important;
    word-break: break-all !important;
    white-space: normal !important;
    line-height: 12px !important;
}

.drawer_top {
    display: flex;
}

.drawer_list {
    padding: 10px;
    border-bottom: 1px solid #e6e6e6;
}
</style>